module.exports = __webpack_public_path__ + "img/play.46a49293.png";